import * as S from './styles'
import type { CardProps } from './types'
import { Image, Text } from '..'

export const Card: React.FC<CardProps> = ({ icon, title, description }) => (
  <S.Container>
    <Image src={icon.src} alt={icon.alt} />
    <Text
      size="h5"
      color="primary"
      align="center"
      lineHeight="b1"
      fontFamily="primary"
    >
      {title}
    </Text>
    <Text
      size="b3"
      color="white"
      align="center"
      lineHeight="b3"
      fontFamily="primary"
    >
      {description}
    </Text>
  </S.Container>
)
